import { render, staticRenderFns } from "./Learners.vue?vue&type=template&id=aea0a1de&scoped=true"
import script from "./Learners.vue?vue&type=script&lang=js"
export * from "./Learners.vue?vue&type=script&lang=js"
import style0 from "./Learners.vue?vue&type=style&index=0&id=aea0a1de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea0a1de",
  null
  
)

export default component.exports